export const defaultInputTheme = {
  token: {
    colorPrimary: '#F7CE17', //var(--Gig_Yellow)
  },
};
